<template>
    <vx-card :title="title">

        <div class="vx-row mt-4">
            <div class="vx-col w-1/2">
                <select-warehouse :isMultiple="false" @data="setWarehouse"></select-warehouse>
                <select-driver @data="setDriver" ref="select_driver"></select-driver>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full flex items-center">
                        <span>Date</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-input v-model="date" type="date" class="w-full mb-6" />
                    </div>
                </div>
            </div>
        </div>

        <!-- button -->
        <div class="vx-row mb-6">
            <div class="vx-col w-1/2">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/4 w-full"></div>
                    <div class="vx-col sm:w-3/4 w-full flex gap-2">
                        <vs-button @click="onClickBtnSearch" color="primary" type="filled" icon-pack="feather"
                            icon="icon-search">
                            Search
                        </vs-button>
                        <vs-button @click="onClickBtnReset" color="danger" type="filled" icon-pack="feather"
                            icon="icon-refresh-cw">
                            Reset
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- table -->
        <div class="vx-row mb-2">
            <div class="core vx-col w-full mb-base">
                <datatable ref="datatable"></datatable>
            </div>
        </div>
    </vx-card>
</template>

<script>
import moment from "moment";
import SelectWarehouse from "./_components/select-warehouse.vue";
import SelectDriver from "./_components/select-driver.vue";
import InputDate from "./_components/input-date.vue";
import Datatable from "./_components/datatable.vue";

export default {
    components: {
        Datatable,
        SelectWarehouse,
        SelectDriver,
        InputDate,
    },
    data() {
        return {
            title: "Daily Closing Dashboard - Driver",
            datatable: [],
            date: this.getToday(),
            driver: {
                id: null,
                name: null,
            },
            warehouses: [],
            personal_id: null,
        };
    },
    mounted() { },
    methods: {
        async onClickBtnSearch() {
            if (this.date == null) {
                this.$vs.notify({
                    title: "Error",
                    text: "Please select date",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });
                return;
            }

            let driver_ids = [];
            driver_ids = this.$refs.select_driver.selected;

            if (!this.$refs.select_driver.selected) {
                driver_ids = this.$refs.select_driver.options;
            }

            if (driver_ids.length > 0) {
                driver_ids = await driver_ids.map((item) => item.id);
            }

            // fetch from datatable ref
            const date_format = this.date;
            await this.$refs.datatable.setDate(date_format);
            await this.$refs.datatable.setDriverIDs(driver_ids.join(","));
            await this.$refs.datatable.getData();
        },
        setDate(date) {
            this.date = date;
        },
        setDriver(id, name) {
            this.driver.id = id;
            this.driver.name = name;
        },
        setWarehouse(selecteds) {
            this.warehouses = selecteds.map((item) => {
                return {
                    id: item.id,
                    code: item.code,
                };
            });
        },
        onClickBtnReset() {
            // reload
            this.$router.go(0);
        },
        getToday() {
            const today = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
        }
    },
    filters: {
        formatDate(value) {
            if (value) {
                return moment(String(value)).format("DD-MM-YYYY");
            }
        },
    },
    watch: {
        warehouses: function (val) {
            if (val.length == 0) {
                return;
            }
            let ids = val.map((item) => item.id);
            let params = {
                warehouse_id: ids.join(","),
                length: 0,
            };
            this.$refs.select_driver.reset();
            this.$refs.select_driver.getDataByTerritory(params);

        },
    },
};
</script>
